<template>
  <div>

      <Grp id="status_prt_ea1"
      :stacked="true"
      :aspectRatio="5"
      :datasets.sync="grp.datasets"
      :labels.sync="grp.labels"/>

  </div>
</template>
<script>
import Grp from '@/components/graphs/Bar.vue';
import {parse_filters} from '@/functions/general.js';
const get_data = (list, key) => list.map(obj => obj[key]);
import filter from '@/components/mixins/filter';
export default {
  props:['ex_filters'],
  mixins:[filter],
  components: { Grp },
  data() {
    return {
      grp_get:'dashboard/status/prt_info',
      colors:['#CC0031','#DF781E','#E8D243','#7CD054'],
      grp_data: {
        ca_per_ea: {with_ea:{},without_ea:{}},
        status_per_general_management:{'Total':{},'Concentradoras':{},'Mina':{},'Cátodos':{},'NPI & CHO':{}}
      },
    };
  },
  computed: {
    rq_name(){ return `bar-prt_files_filter`},
    grp() {
      const dataBar = {labels: ['Cátodos','Concentradoras', 'Mina', 'NPI & CHO','Totales'], datasets: []};
      const {Total,Concentradoras,Mina,'Cátodos':Catodos,'NPI & CHO': NPI_and_CHO} = this.grp_data.status_per_general_management;
      const g_t = (key) => get_data([Catodos,Concentradoras,Mina,NPI_and_CHO,Total],key);

      dataBar.datasets = [
        {
          label: 'Vigente',
          data: g_t('current'),
          backgroundColor: this.colors[3],
          borderColor: this.colors[3],
        },
        {
          label: '3 meses',
          data: g_t('3mm'),
          backgroundColor: this.colors[2],
          borderColor: this.colors[2],
        },
        {
          label: '1 mes',
          data: g_t('1mm'),
          backgroundColor: this.colors[1],
          borderColor: this.colors[1],
        },
        {
          label: 'Caducado',
          data: g_t('expired'),
          backgroundColor: this.colors[0],
          borderColor: this.colors[0],
        },
      ];
      return dataBar;
    },
  },
  watch:{
    'ex_filters':{
      deep: true,
      handler(v){ this.get_grp_data() }
    },
    'myRequestStatus.rq'(v){ if (v) this.set_count() }
  },
  created() {
    this.get_grp_data();
  }, // created
  methods: {
    get_grp_data(){
      this.requests.get[this.grp_get](null,parse_filters(this.ex_filters))
        .then(r => this.grp_data = r);
    },
		resetRqStatus(){
      this.myRequestStatus.status = false;
      this.myRequestStatus.ticking = false;
    },
  },
};
</script>
